import React from 'react';
import { USBGrid, USBColumn, USBButton } from '@usb-shield/components-react';
import './requirementNotFound.css';

const RequirementNotFound = () => {
  const goBack = () => {
    if (typeof window !== 'undefined') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/ReportingDashboard';
      }
    }
  };

  const goToPortfolio = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/ReportingDashboard';
    }
  };

  return (
    <>
      <USBGrid>
        <USBColumn largeSpan={2} />
        <USBColumn largeSpan={12}>
          <div className="req-not-found-container">
            <div className="req-not-found-image" />
            <div className="req-not-found-heading">
              Requirement not found
            </div>
            <div className="req-not-found-subtext">
              <p>
                The requirement you are looking for does not exist or may have
                been removed. Please check the requirement ID and try again.
              </p>
            </div>
            <div className="req-not-found-actions">
              <USBButton variant="primary" handleClick={goBack}>
                Go back
              </USBButton>
              {/* <USBButton variant="primary" handleClick={goToPortfolio}>
                Go to Portfolio
              </USBButton> */}
            </div>
          </div>
        </USBColumn>
        <USBColumn largeSpan={2} />
      </USBGrid>
    </>
  );
};

export default RequirementNotFound;
